module.exports = __webpack_public_path__ + "img/minus-circle.6c36f490.svg";